import { create } from "zustand";

interface TenantStore {
  currentTenant: string | null;
  setCurrentTenant: (tenant: string | null) => void;
  getCurrentTenant: () => string | null;
}

export const useTenantStore = create<TenantStore>((set, get) => ({
  currentTenant: null,
  getCurrentTenant: () => {
    const currentTenant = get().currentTenant;
    if (currentTenant) {
      return currentTenant;
    }
    // Stores that call this at module evaluation are also evaluated during SSR,
    // where there is no URL to read the tenant from.
    if (typeof window === "undefined") {
      return null;
    }
    const pathname = window.location.pathname;
    const tenantFromUrl = pathname.split("/")[1];
    // Only return if it's not a special route
    if (tenantFromUrl && tenantFromUrl !== "login" && tenantFromUrl !== "api") {
      return tenantFromUrl;
    }
    return null;
  },
  setCurrentTenant: (tenant) => set({ currentTenant: tenant }),
}));

// Generic tenant change listener utility
export const onTenantChange = (callback: (tenant: string | null) => void) => {
  let currentTenant: string | null = null;

  return useTenantStore.subscribe((state) => {
    if (state.currentTenant !== currentTenant) {
      currentTenant = state.currentTenant;
      callback(state.currentTenant);
    }
  });
};
